import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  standardUsers: [],
  _standardUsers: {},
  singleStandardUser: {},
  updateData: {},
  pagination: { pages: 0 },
  errors: {},
  redirectTo: null,
  success: false,
  message: '',
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getStandardUser = createAsyncThunk(
  'standardUsers/subusersteam',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await Agent.subStandardUserTeam.getSubUsersTeam(payload);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const addNewSubStandardUserTeam = createAsyncThunk(
  'standardUsersTeam/create',
  async (data, { rejectWithValue }) => {
    try {
      return await (
        await Agent.subStandardUserTeam.create(data)
      ).data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const updateSubStandardUserTeam = createAsyncThunk(
  'substandardUsers/updateSubusersteam',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await Agent.subStandardUserTeam.updateSubUsersTeam(payload);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

export const deleteSubStandardUserTeam = createAsyncThunk(
  'substandardUsers/deleteSubUserteam',
  async (payload, { rejectWithValue }) => {
    try {
      return await (
        await Agent.subStandardUserTeam.deleteSubUserTeam(payload)
      ).data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);



const substandardUserTeamSlice = createSlice({
  name: 'subStandardUserTeam',
  initialState,
  reducers: {
    setLoading(state) {
      state.success = false;
      state.loading = true;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getStandardUser.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [getStandardUser.fulfilled]: (state, action) => {
      let pagination = action?.payload?.pagination || empty_pagination;
      let standardUsers = action?.payload?.data || [];

      state.loading = false;
      state.success = false;
      state.message = ''

      /**
       * Sometimes second page is loaded before first page so handle this issue :
       *  If current page of pagination from API is greater than state's current page, save current page from API.
       */
      // state.pagination =
      //   pagination.currentPage > (state.pagination.currentPage || 0)
      //     ? pagination
      //     : state.pagination;

      state.pagination = pagination;
      state._standardUsers[pagination.currentPage] = standardUsers;

      /**
       * Current: takes a transaction of the current state of a draft and finalizes it (but without freezing).
       */
      const standardUsersArray = current(state._standardUsers);

      let sortedStandardUsersArray = [];

      /**
    * Loop through pages of object containing array of transactions.
    * FIXED: unarranged data in table list gets set when pages are not loaded serially.
    */
      for (let i = 1; i <= state?.pagination?.currentPage; i++) {
        if (standardUsersArray[i]) {
          sortedStandardUsersArray = [
            ...sortedStandardUsersArray,
            ...standardUsersArray[i],
          ];
        }
      }

      state.standardUsers = sortedStandardUsersArray;
    },

    [getStandardUser.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },

    [addNewSubStandardUserTeam.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [addNewSubStandardUserTeam.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = 'Team successfully created';
      if (action?.payload?.data) {
        state.standardUsers = [...state.standardUsers, action?.payload?.data];
      }
    },

    [addNewSubStandardUserTeam.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },


    // UpdateSubStandardUser

    [updateSubStandardUserTeam.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [updateSubStandardUserTeam.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = 'User successfully updated';
      const data = current(state.standardUsers);
      const index = data.findIndex((item) => {
        return item._id === action?.payload?.data?._id;
      });
      if (index === -1) return;
      let user = action?.payload?.data || '';

      state.standardUsers[index] = user;
    },

    [updateSubStandardUserTeam.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },
    // deleteTeam

    [deleteSubStandardUserTeam.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },

    [deleteSubStandardUserTeam.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = 'Team successfully deleted';
      const data = current(state.standardUsers);
      const index = data.findIndex((item) => {
        return item._id === action?.payload?.data?._id;
      });
      if (index === -1) return;
      // let user = action?.payload?.data|| '';
      const final = [
        ...data.slice(0, index),
        ...data.slice(index + 1)
      ];
      state.standardUsers = final;
    },

    [deleteSubStandardUserTeam.rejected]: (state, action) => {
      state.loading = false;
      state.success = false;
      state.errors = action?.payload?.errors || {};
    },


  },
});

export const standardUsersTeamSelector = (state) => state.subStandardUserTeam;

export const { reducer, actions } = substandardUserTeamSlice;
